import { render, staticRenderFns } from "./shogiBoard.vue?vue&type=template&id=427e7d3b&scoped=true&"
import script from "./shogiBoard.vue?vue&type=script&lang=js&"
export * from "./shogiBoard.vue?vue&type=script&lang=js&"
import style0 from "./shogiBoard.vue?vue&type=style&index=0&id=427e7d3b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "427e7d3b",
  null
  
)

export default component.exports